import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HTTPService } from 'src/app/services/http.service';
import { DialogService } from 'src/app/services/dialog.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Validators } from 'ngx-editor';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { NgxSpinnerService } from 'ngx-spinner';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { Subscription, interval, startWith, switchMap, tap } from 'rxjs';
import { faCheck, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { ThemeService } from 'src/app/services/theme.service';
import { environment } from 'src/environments/environment';

export interface DialogData {
  action: any;
  function: any,
  selected:any;
  parameters:any;
}



@Component({
    selector: 'app-flowaction',
    templateUrl: './flowaction.component.html',
    styleUrls: ['./flowaction.component.scss'],
    standalone: false
})
export class FlowModalComponent implements OnInit {  

  firstFormGroup: FormGroup;
  codecompany:Number;
  codecontract:Number;
  conditionSearch:string = '0=0';
  showLoading = false;
  loading = false;
  sub: Subscription;
  logs = []; 
  flowRunning = false;
  statusMessage: string;
  containsExpression = false;
  idConfig = null;
  configName = "";
  showCodeCompany: boolean = false;
  sub3: Subscription;
  faCircleNotch = faCircleNotch;
  faCheck = faCheck;
  faWarning = faWarning;
  nmStatus: string = '';
  nmElapsedMs: number = 0;
  nmError: boolean = false;
  nmErrorMessage: string | null = null;
  nmJobId: string | null = null;
  subNm: Subscription;


  
  constructor(
    public dialogRef: MatDialogRef<FlowModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private http:HTTPService, private cdr:ChangeDetectorRef, private dialogServices:DialogService, private fb: FormBuilder, public uas:UserAuthenticationServices,   private snackBar: SnackbarService, private spinner: NgxSpinnerService,
    public ThemeService:ThemeService) {      
    }

  onNoClick(): void {
    this.dialogRef.close();
  }



  get isNewMode(): boolean {
    return this.data?.action?.TYPE === 'NM';
  }

  ngOnInit(): void { 
    

    this.firstFormGroup = this.fb.group({      
      IDCONF: ["", Validators.required],              
    });

    if  (this.uas.user.companylist.length > 1 ){ 
      this.codecompany = null;
      this.codecontract = null;
    }else{
      this.codecompany = Number(this.uas.user.companylist[0].codecompany);
      this.codecontract = Number(this.uas.user.companylist[0].codecontract)              
    }

    if(this.data.action.EXPRESSION){
      let expressionJson = JSON.parse(this.data.action.EXPRESSION);

      this.codecompany = expressionJson.codeCompany;
      this.idConfig = expressionJson.idConf;
      this.showCodeCompany = expressionJson.showCodeCompany;

      if(!this.codecompany){ //FIX: Permitir expressao sem codecompany. Travar apenas no fluxo.
       // throw Error("É necessário preencher a chave codecompany no campo expressão da ação para o Fluxo!");
      }

      if(!this.idConfig){
        throw Error("É necessário preencher a chave idConf no campo expressão da ação para o Fluxo!");
      }

      this.containsExpression = true;


      if(this.codecompany){
        this.getConfiguracaoName();
      }

      this.firstFormGroup.patchValue({
        IDCONF: expressionJson.idConf,
      });      
    }

    this.conditionSearch = `(CODECOMPANY = 0  AND  EXISTS (SELECT 1 FROM Mktpcfgcompany cfg WHERE cfg.idconf = idconf and cfg.codecompany = ${this.codecompany} ) )  OR  CODECOMPANY <> 0`;      

  }

  ngOnDestroy(){
      if ( this.sub3 != null ){
          this.sub3.unsubscribe();
      }
      if ( this.sub != null ){
        this.sub.unsubscribe();
    }
    if (this.subNm != null) { this.subNm.unsubscribe(); }
  }

  getConfiguracaoName(){
    let buscaName = {
      "entityName":"Mktpcfg",
      "sql":`SELECT NAME
            FROM Mktpcfg 
            WHERE CODECOMPANY =${this.codecompany}            
            AND IDCONF = ${this.idConfig}`            
    };

    let self = this;
     
    this.http.post(buscaName,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
                  
      if( ObjectUtil.isNotEmpty(con['SQL'])){
        self.configName  = con['SQL'][0]['NAME'];        
      }else{
        throw Error(`Configuração ${this.idConfig}  não encontrada!`);
      }
      });
  }

  getActiveCompanies(){
    let ob = {
      "entityName":"Mktpactivecompanies",
      "sql":`SELECT A.*
            FROM MKTPACTIVECOMPANIES A INNER JOIN MKTPCOMPANIES B ON A.CODECOMPANY=B.CODECOMPANY
            WHERE A.CODECOMPANY=${this.codecompany}            
            AND A.STATUS=1
            AND A.ENVIRONMENT=1`
    }

    let self = this;
     
    this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
         
        if( ObjectUtil.isNotEmpty(con['SQL'])){
          this.conditionSearch = `(CODECOMPANY = 0  AND ONLINE ='S' AND  EXISTS (SELECT 1 FROM Mktpcfgcompany cfg WHERE cfg.idconf = idconf and cfg.codecompany = ${this.codecompany} ) )  OR  CODECOMPANY =  ${this.codecompany} AND ONLINE = 'S'`;      
        }else{
          throw Error('Empresa não configurada!');
        }
      });
  }

  executeFlow(){
    if (this.isNewMode) { this.executeFlowNewMode(); return; }

    var idConf = this.firstFormGroup.get("IDCONF").value;

    if(!idConf){
      throw Error("É necessário selecionar um Fluxo para execução");
    }

    this.logs = [];

    if(!this.codecompany){
      //throw Error("É necessário selecionar uma empresa!");
    }
    
    this.data.action.IDCONF = idConf;

    this.data.action.CODECOMPANY = this.codecompany;

    if ( !this.showCodeCompany ){
        delete this.data.action.CODECOMPANY;
    }
    
    //let spinnerMsg = "Executando configuração "+idConf;
    let spinnerMsg = "Mktpcfg";

    this.statusMessage = "Preparando execução do fluxo "+idConf+" ...";

    
    this.spinner.show(spinnerMsg);

    this.flowRunning = true;
    
    this.http
      .executeBackEndAction(
        "Mktpcfg",
        this.data.action,
        this.data.selected,
        this.data.parameters,
        false
      )
      .subscribe(
        (sucesso) => {
          let jobs: string[] = sucesso["jobs"];

          let mensagemFinal: string = "";

          if (ObjectUtil.isNotEmpty(jobs)) {
            
            this.snackBar.showSuccess("Executando Fluxo "+idConf);

            this.statusMessage = "Executando Fluxo "+idConf+" ...";

            this.startPolling(jobs);

         
            
           // this.showLoading = false;
          // this.loading = false;
                                                
            
          } else {
            this.snackBar.showSuccess("Não foi possível executar o Fluxo "+idConf);
          }
          this.spinner.hide(spinnerMsg);
        },
        (exception) => {
          this.spinner.hide(spinnerMsg);
          this.flowRunning = false;
          this.statusMessage = "";
          throw exception;
          
        }
      );

   // this.data.function(this.data.action);    
  
  }

  executeFlowNewMode() {
    const idConf = this.firstFormGroup.get('IDCONF').value;
    if (!idConf) { throw Error('E necessario selecionar um Fluxo para execucao'); }

    let contextoAcao = 'EXECUTAR';
    try {
      const expr = JSON.parse(this.data.action.EXPRESSION || '{}');
      if (expr.contextoAcao) { contextoAcao = expr.contextoAcao; }
    } catch (_) {}

    const payload = {
      idconf: Number(idConf),
      codecompany: this.codecompany,
      codemktp: null,
      sequence: 0,
      context: {
        __contextoAcao: contextoAcao,
        __userName: this.uas.user?.username ?? null,
        __logEnabled: true,
      },
      rows: this.data.selected ?? [],
    };

    this.flowRunning = true;
    this.nmStatus = 'PENDING';
    this.statusMessage = `Preparando execucao do fluxo ${idConf}...`;
    this.spinner.show('Mktpcfg');

    this.http.post(payload, 'FlowServices/runOnlineAsync', false, true, true)
      .subscribe({
        next: (res: any) => {
          this.spinner.hide('Mktpcfg');
          if (!res?.ok || !res?.idjob) {
            this.flowRunning = false;
            this.nmError = true;
            this.nmErrorMessage = res?.message ?? 'Backend nao retornou idjob valido.';
            this.statusMessage = 'Erro ao iniciar fluxo.';
            return;
          }
          this.nmJobId = res.idjob;
          this.snackBar.showSuccess(`Fluxo ${idConf} iniciado`);
          this.statusMessage = `Executando Fluxo ${idConf}...`;
          this.startPollingNewMode(res.idjob, idConf);
        },
        error: (err: any) => {
          this.spinner.hide('Mktpcfg');
          this.flowRunning = false;
          throw err;
        },
      });
  }

  startPollingNewMode(idjob: string, idConf: any) {
    const terminal = ['COMPLETED', 'ERROR', 'STOPPED', 'NOT_FOUND'];
    this.subNm = interval(1500)
      .pipe(
        startWith(0),
        switchMap(() => this.http.post({ idjob }, 'FlowServices/jobStatus', false, true, true)),
        tap((res: any) => {
          this.nmStatus = res?.status ?? 'RUNNING';
          this.nmElapsedMs = res?.elapsedMs ?? 0;
          this.nmError = res?.error === true;
          this.nmErrorMessage = res?.errorMessage ?? null;
          if (terminal.includes(this.nmStatus)) {
            this.subNm.unsubscribe();
            this.flowRunning = false;
            this.statusMessage = this.nmError
              ? `Fluxo ${idConf} finalizado com erro.`
              : `Fluxo ${idConf} concluido com sucesso!`;
          }
        })
      )
      .subscribe();
  }

  startPolling(jobs: string[]) {


    let obinfo = {
      "entityName":"Mktplgi",
      "sql":`SELECT LGI.SEQUENCE, LGI.IDJOB, LGI.IDCONF, LGI.EXECORDER, LGI.REQUEST, LGI.RESPONSE,  LGI.RECMODIFYON as RECMODIFYON, LGI.STATUS, LGI.MESSAGE, LGI.URL FROM MKTPLGI LGI  WHERE LGI.IDJOB in ('${jobs}') ORDER BY EXECORDER ASC`
    }      
    
      this.sub = interval(5000)
    .pipe(
      startWith(0),
      switchMap(() => this.http.post(obinfo,'JsonBrokerServices/findnative',false,true,true)), 
      tap((res: any) => {
         
          let obName = {
            "entityName":"Mktplgi",
            "sql":`SELECT SEQUENCE, NAME FROM MKTPCFI WHERE IDCONF=${res["SQL"][0]["IDCONF"]}`
          }
          
          this.sub3 = this.http.post(obName, 'JsonBrokerServices/findnative',false,true,true).subscribe(data=>{

            let dataCfi:Object[] = data['SQL'];

            
            for ( var sql of res['SQL'] ){
              let name = dataCfi.find(d=>d['SEQUENCE'] == sql['SEQUENCE'])['NAME'];
              sql['NAME'] = name;
            }
              
            this.logs = res['SQL'].map(log => ({ ...log, expanded: false })); 

            let unfinishedLogs = this.logs.some(log => log.STATUS === 0); 
        
            if (!unfinishedLogs) {
              this.sub.unsubscribe(); 
              var idConf = this.firstFormGroup.get("IDCONF").value;          
              this.statusMessage = "Fluxo "+idConf+" Processado !";
              this.flowRunning = false;
            }
          });

        
        
      })
    )
    .subscribe();
  }

  get completedLogs() {
    return this.logs.filter(log => log.STATUS !== 0).length;
  }
  
  get totalLogs() {
    return this.logs.length;
  }

  getProcessValue(){
    if ( this.totalLogs == 0 ){
      return 0;
    }else{
      return (this.completedLogs / this.totalLogs) * 100  ;
    }
    
  }

}
